var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcNoData = function SvgIcNoData(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 119,
    viewBox: "0 0 174 123",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6264 111.45C116.257 111.45 140.401 87.3612 140.401 57.775C140.301 28.0888 116.257 4 86.6264 4C56.8956 4 32.8516 28.0888 32.8516 57.675C32.8516 87.3612 56.8956 111.45 86.6264 111.45Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81688_421429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.994 64.5693C143.994 76.0639 134.715 85.3596 123.142 85.3596C122.943 85.3596 121.247 85.3596 108.776 85.3596C100.096 85.3596 86.2282 85.3596 64.0798 85.3596H53.5044C39.6367 85.6594 28.5625 74.5646 28.5625 61.1708C28.5625 47.6771 39.7365 36.4823 53.8037 37.182C65.8756 -0.600391 121.147 4.69714 125.836 43.7789C136.212 45.0783 143.994 53.8742 143.994 64.5693Z",
    fill: "url(#paint0_linear_81688_421429)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.141 85.3619C134.614 85.3619 143.992 76.0662 143.992 64.5716C143.992 53.0769 134.614 43.7812 123.141 43.7812C111.667 43.7812 102.289 53.0769 102.289 64.5716C102.289 76.0662 111.667 85.3619 123.141 85.3619Z",
    fill: "url(#paint1_linear_81688_421429)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1214 85.5639C109.574 85.5639 126.235 68.9716 126.235 48.4812C126.235 27.9907 109.574 11.3984 89.1214 11.3984C68.669 11.3984 52.0078 27.9907 52.0078 48.4812C52.0078 68.9716 68.5693 85.5639 89.1214 85.5639Z",
    fill: "url(#paint2_linear_81688_421429)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4003 57.9989C76.9713 57.9989 78.3006 56.6671 78.3006 55.0932C78.3006 53.5193 76.9713 52.1875 75.4003 52.1875C73.8293 52.1875 72.5 53.5193 72.5 55.0932C72.5 56.6671 73.8293 57.9989 75.4003 57.9989Z",
    fill: "#989FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6347 57.9989C99.2056 57.9989 100.535 56.6671 100.535 55.0932C100.535 53.5193 99.2056 52.1875 97.6347 52.1875C96.0637 52.1875 94.7344 53.5193 94.7344 55.0932C94.7344 56.7882 96.0637 57.9989 97.6347 57.9989Z",
    fill: "#989FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2868 45.4781L68.9062 48.9297L69.7678 50.5282L76.1484 47.0766L75.2868 45.4781Z",
    fill: "#989FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2441 45.4325L96.3828 47.0312L102.764 50.4821L103.625 48.8834L97.2441 45.4325Z",
    fill: "#989FB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5165 64.7724C88.3852 64.7724 89.9002 63.6341 89.9002 62.23C89.9002 60.8258 88.3852 59.6875 86.5165 59.6875C84.6477 59.6875 83.1328 60.8258 83.1328 62.23C83.1328 63.6341 84.6477 64.7724 86.5165 64.7724Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0488 18.3516C17.0488 18.3516 3.10268 21.899 7.32876 24.737C11.5548 27.433 21.5566 32.1157 30.9948 28.9939C40.4331 25.8722 30.9948 21.4733 31.1357 21.4733C31.2766 21.4733 17.0488 18.3516 17.0488 18.3516Z",
    fill: "#CED7E2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.2159C5.0713 18.7768 20.7078 16.2226 30.7095 9.69531C38.5982 19.4863 41.5565 22.0404 44.3739 22.3242C40.0069 26.7231 25.4974 33.818 17.3269 24.5946C7.74782 30.6962 0 17.2159 0 17.2159Z",
    fill: "#E9EDF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.766 52.6896C135.119 52.9734 149.628 46.4461 157.517 37.6484C167.66 45.169 171.04 46.8718 173.999 46.4461C170.759 51.8382 160.898 63.6158 146.952 64.4672C136.809 58.5075 129.766 52.6896 129.766 52.6896Z",
    fill: "#E9EDF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0322 119.253C85.9731 113.989 76.049 101.536 65.5795 96.0734C70.323 84.3589 71.1269 80.6544 69.9785 77.89C75.998 79.6906 89.8394 86.3247 94.1363 99.6442C90.9017 110.97 87.0322 119.253 87.0322 119.253Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81688_421429",
    x: 6.5625,
    y: 0.484375,
    width: 159.43,
    height: 117.883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81688_421429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81688_421429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81688_421429",
    x1: 86.2781,
    y1: 42.0149,
    x2: 86.2404,
    y2: 86.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_81688_421429",
    x1: 100.07,
    y1: 39.3051,
    x2: 118.592,
    y2: 59.5251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_81688_421429",
    x1: 48.5325,
    y1: 31.4649,
    x2: 77.6803,
    y2: 42.8501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcNoData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-no-data.e0b5bb38.svg";
export { ForwardRef as ReactComponent };